export function findErrorResponse(response) {

    let error_entry = Array.isArray(response) ?
        response.filter(item => item.hasOwnProperty('type') && ((item.type === 'api_error') ||
            (item.type === "mysql")))
        : response.hasOwnProperty('error_api') && response.error_api.hasOwnProperty('api_error') ?
            response.error_api.api_error :
            response.hasOwnProperty('error_api') && response.error_api.hasOwnProperty('mysql')
                ? response.error_api.mysql
                : null
    ;

    let errors = '';

    if (Array.isArray(error_entry) && !!error_entry.length) {
        error_entry.forEach(e => {

            if (typeof e.error === 'string') {
                errors += `${e.error},`;
            } else {
                for (const key in e.error) {
                    if (Object.prototype.hasOwnProperty.call(e.error, key)) {
                        errors += `${e.error[key]},`;
                    }
                }
            }
        });
    }

    return errors;
}


export function filterObjectByKeys(obj, keysToKeep) {
    return Object.keys(obj).reduce((acc, key) => {
        if (keysToKeep.includes(key)) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
}

export function unFilterObjectByKeys(obj, keysToKeep) {
    return Object.keys(obj).reduce((acc, key) => {
        if (!keysToKeep.includes(key)) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
}
export function isEmail(value) {
    // Check if the value is a string
    if (typeof value !== 'string') {
        return false;
    }

    // Basic email pattern check (you can enhance this pattern based on your needs)
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value);
}
